<template>
  <v-app
    class="dt-theme"
    :class="appThemeClass"
    :style="{
      '--scrollbar-width': scrollBarWidth + 'px',
    }"
  >
    <!-- <v-navigation-drawer
      :class="mainNavClass"
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      :width="200"
      enable-resize-watcher
      fixed
      app
    >
    <MainNavigationComponent
    :items="items"
    />
    </v-navigation-drawer>
    <v-content>
      <v-layout column align-center>
        <MainBreadcrumb :class="{'inactive': !this.$store.getters.mainNavActive}"></MainBreadcrumb>
        <router-view/>
      </v-layout>
    </v-content>
    <ConfirmationContainer></ConfirmationContainer> -->

    <router-view />
  </v-app>
</template>


<script>
import * as R from "ramda";
import * as RA from "ramda-adjunct";
import * as D from "date-fns";
import * as S from "sanctuary";
import * as querystring from "qs";
import * as Utility from "./utility";
import Vue from "vue";
import { i18n } from "./i18n/index";
import { JSONX, mapChanges, mapCommonValues } from "./utility";
import { waitForExistence,_BandCamp, } from "../src/dt-plugins/module-plugins/bandcamp";
import { Scroller } from "./utility/scroller";
import * as ActionTypes from "./store/app/types";
import { dispatch } from "rxjs/internal/observable/pairs";
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as I18nActionTypes from "./store/app/i18n/types";
// TODO: Remove ramda export to windows in production build
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;
window.R = R;
// window.RA = RA;
// window.S = S;
window.D = D;
// window.Q = querystring;
// window.Utility = Utility;

window.mapChanges = mapChanges;
window.mapCommonValues = mapCommonValues;

export default {
  // components: {
  //   MainNavigationComponent,
  //   MainBreadcrumb,
  //   ConfirmationContainer
  // },
  mounted() {

    //this.getBandCamp();
    // Assigning App Component This to Window
    window.VAPP = this;
    Scroller.init();
    this.scrollBarWidth = Scroller.scrollbar_width();
    // this.$store.dispatch(ActionTypes.FETCH_REQUEST_COUNT);
  },
  data() {
    return {
      scrollBarWidth: 0,
      appThemeClass: {
        light: true,
      },
      // clipped: false,
      // fixed: false,
      // miniVariant: false,
      // right: true,
      // rightDrawer: false,
      // title: 'Vuetify.js'
    };
  },
  methods: {
    getBandCamp() {
      const json = JSON.stringify(_BandCamp);
      console.log("json", json);
      const el = document.getElementById("distribution_orders_tab");
      let {result} = JSONX.tryParse(json);
      console.log("result", result);
      const { template, script, name } = result;
      const tempCompile = Vue.compile(template);
      window[name] = {};
      const scriptEL = document.createElement("script");
      scriptEL.innerHTML = script;
      document.body.append(scriptEL);
      const fragment = {
        ...tempCompile,
        ...window[name],
      };

      const dynamicThing = new Vue({
        i18n,
        render: (h) => h(fragment),
      });
      dynamicThing.$mount(el);
    },
  },

  // name: 'App',

  // computed: {
  //   drawer: {
  //     get () {
  //       return this.$store.getters.appDrawer;
  //     },
  //     set () {

  //     }
  //   },
  //   mainNavClass: function() {
  //     return {
  //       'main-nav': true,
  //       inactive: !this.$store.getters.mainNavActive
  //     };
  //   },
  //   items: function () {
  //     return this.$store.getters.appNavItems;
  //   }
  // }
};
</script>

<style lang="scss">
@import "./style/index.scss";
@import "./style/inactive.scss";

$fa-font-path: "~@fortawesome/fontawesome-free-webfonts/webfonts";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fontawesome.scss";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fa-solid.scss";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fa-regular.scss";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fa-brands.scss";

.list {
  // margin-top: 50px;
}

.inactive.main-nav,
.inactive.toolbar {
  // --bc-primary: var(--bc-inactive);
  // --bc-3: var(--bc-3-inactive);
  // --bc-4: var(--bc-4-inactive);
  // --text-primary: var(--text-inactive);
  // --sprt-82: var(--sprt-4);

  @include overlayInactive();
}

aside.navigation-drawer.navigation-drawer--fixed {
  background: var(--bc-3, #f6f6f6);
}

.list__group__header {
  color: var(--text-primary, black);
}

.navigation-drawer.navigation-drawer--clipped {
  box-shadow: none !important;
}

.toolbar.toolbar--fixed {
  box-shadow: none !important;
}

.main-nav {
  height: 100px;
  .navigation-drawer__border {
    background: transparent !important;
  }
}

@media only screen and (min-width: 1264px) {
  .container {
    max-width: 100%;
  }
}

@media only screen and (min-width: 960px) {
  .container {
    max-width: 100%;
  }
}
.content {
  height: 100%;
  max-height: 100%;
  overflow: auto;
}
@media only screen and (max-width: 599px) {
  .b2b-content {
    padding-top: 25px !important;
  }
}
</style>
